import { render, staticRenderFns } from "./substitution.vue?vue&type=template&id=fcc5da52&"
import script from "./substitution.vue?vue&type=script&lang=js&"
export * from "./substitution.vue?vue&type=script&lang=js&"
import style0 from "./substitution.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports